import { render, staticRenderFns } from "./Despacho_Harina.vue?vue&type=template&id=455b5c90&scoped=true&"
import script from "./Despacho_Harina.vue?vue&type=script&lang=js&"
export * from "./Despacho_Harina.vue?vue&type=script&lang=js&"
import style0 from "./Despacho_Harina.vue?vue&type=style&index=0&id=455b5c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b5c90",
  null
  
)

export default component.exports